"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gameplay = void 0;
const button_arrow_black_png_1 = __importDefault(require("../../img/button/button_arrow_black.png"));
const button_arrow_red_png_1 = __importDefault(require("../../img/button/button_arrow_red.png"));
class Gameplay {
    constructor() {
        this.imageList = [];
        this.imageCache = {};
        this.imageRotationIntervals = new Map();
        this.showCorrectGameplaySection = (sectionToShow) => {
            this.sections.forEach(area => {
                area?.classList.add('gameplay__hide');
            });
            switch (sectionToShow) {
                case 'action':
                    this.action?.classList.remove('gameplay__hide');
                    break;
                case 'customize':
                    this.customize?.classList.remove('gameplay__hide');
                    break;
                case 'fusion':
                    this.fusion?.classList.remove('gameplay__hide');
                    break;
                case 'online':
                    this.online?.classList.remove('gameplay__hide');
                    break;
                case 'deep':
                    this.deep?.classList.remove('gameplay__hide');
                    break;
                default:
                    this.action?.classList.remove('gameplay__hide');
                    break;
            }
            this.canIClick = true;
        };
        this.gameplayButtonHandlers = () => {
            const gameplaySelectors = document.querySelectorAll('.gameplay__selector__choice');
            gameplaySelectors.forEach(selector => {
                selector.addEventListener('click', e => {
                    e.preventDefault();
                    const target = e.target.closest('.gameplay__selector__choice');
                    if (!target || !this.canIClick)
                        return;
                    const section = selector.getAttribute('data-gameplay');
                    if (!section || section === 'inactive')
                        return;
                    this.canIClick = false;
                    const previousActive = document.querySelector('.gameplay__selector__active .btn');
                    const previousArrow = previousActive?.querySelector('.btn__arrow');
                    previousActive?.classList.remove('btn--active');
                    if (previousArrow) {
                        previousArrow.src = button_arrow_black_png_1.default;
                    }
                    document
                        .querySelector('.gameplay__selector__active')
                        ?.classList.remove('gameplay__selector__active');
                    target.classList.add('gameplay__selector__active');
                    const activeBtn = target.querySelector('.btn');
                    const activeArrow = activeBtn?.querySelector('.btn__arrow');
                    activeBtn?.classList.add('btn--active');
                    if (activeArrow) {
                        activeArrow.src = button_arrow_red_png_1.default;
                    }
                    this.showCorrectGameplaySection(section);
                });
            });
        };
        this.gameplayScreenShotSwapHandler = (containerClass) => {
            const container = document.querySelector(containerClass);
            if (!container)
                return;
            const pictureElement = container.querySelector('.gameplay__image__group picture');
            if (!pictureElement)
                return;
            const imgElement = pictureElement.querySelector('img');
            const sourceElements = pictureElement.querySelectorAll('source');
            const smallImageWrappers = container.querySelectorAll('.gameplay__image__wrapper');
            smallImageWrappers.forEach(imageWrapper => {
                imageWrapper.addEventListener('click', () => {
                    if (imageWrapper.classList.contains('gameplay__image__active'))
                        return;
                    const img = imageWrapper.querySelector('img');
                    if (img && img.dataset.name && imgElement) {
                        const dataName = img.dataset.name;
                        const pictureString = this.createPictureElementString(dataName);
                        // Create a temp DOM element to parse the new <picture>
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = pictureString;
                        const fallbackImg = tempDiv.querySelector('img');
                        const newSources = tempDiv.querySelectorAll('source');
                        if (fallbackImg) {
                            const newImage = new Image();
                            newImage.src = fallbackImg.src;
                            newImage.onload = () => {
                                // Fade out
                                pictureElement.style.opacity = '0';
                                setTimeout(() => {
                                    // Update image src
                                    imgElement.src = fallbackImg.src;
                                    // Update each <source> tag
                                    sourceElements.forEach((sourceEl, i) => {
                                        const newSource = newSources[i];
                                        if (newSource) {
                                            const srcset = newSource.getAttribute('srcset');
                                            const type = newSource.getAttribute('type');
                                            const media = newSource.getAttribute('media');
                                            if (srcset)
                                                sourceEl.setAttribute('srcset', srcset);
                                            if (type)
                                                sourceEl.setAttribute('type', type);
                                            if (media)
                                                sourceEl.setAttribute('media', media);
                                        }
                                    });
                                    // Fade back in
                                    pictureElement.style.opacity = '1';
                                    // Update active thumbnail
                                    container
                                        .querySelector('.gameplay__image__active')
                                        ?.classList.remove('gameplay__image__active');
                                    imageWrapper.classList.add('gameplay__image__active');
                                    // Start/stop rotation based on image name
                                    if (dataName === 'spoils' ||
                                        dataName === 'spoils2' ||
                                        dataName === 'prize' ||
                                        dataName === 'fusion' ||
                                        dataName === 'supply2' ||
                                        dataName === 'enemies' ||
                                        dataName === 'enemies3') {
                                        this.startImageRotation(pictureElement, dataName);
                                    }
                                    else {
                                        this.stopImageRotation(pictureElement);
                                    }
                                }, 250); // Fade timing
                            };
                            newImage.onerror = error => {
                                console.error(`Failed to load image: ${fallbackImg.src}`, error);
                            };
                        }
                    }
                });
            });
        };
        this.canIClick = true;
        this.action = document.getElementById('action');
        this.customize = document.getElementById('customize');
        this.fusion = document.getElementById('fusion');
        this.online = document.getElementById('online');
        this.deep = document.getElementById('deep');
        this.backgroundImage = document.querySelector('.gameplay__selection__bg');
        this.sections = [
            this.action,
            this.customize,
            this.fusion,
            this.online,
            this.deep,
        ].filter((el) => el !== null);
        this.init();
    }
    importAll(r) {
        return r.keys().map(r);
    }
    // in html change the gameplay__images__immortals to next item and change the data-name="" of small images will work if maintain naming of images
    init() {
        this.gameplayButtonHandlers();
        this.showCorrectGameplaySection('action');
        this.gameplayScreenShotSwapHandler('.gameplay__images__immortals');
        this.gameplayScreenShotSwapHandler('.gameplay__images__weaponry');
        this.gameplayScreenShotSwapHandler('.gameplay__images__armament');
        this.gameplayScreenShotSwapHandler('.gameplay__images__heavyarmor');
        this.gameplayScreenShotSwapHandler('.gameplay__images__armory');
        this.gameplayScreenShotSwapHandler('.gameplay__images__spoils');
        this.gameplayScreenShotSwapHandler('.gameplay__images__canvas');
        this.gameplayScreenShotSwapHandler('.gameplay__images__customization');
        this.gameplayScreenShotSwapHandler('.gameplay__images__fusion');
        this.gameplayScreenShotSwapHandler('.gameplay__images__overpower');
        this.gameplayScreenShotSwapHandler('.gameplay__images__character');
        this.gameplayScreenShotSwapHandler('.gameplay__images__coop');
        this.gameplayScreenShotSwapHandler('.gameplay__images__mercenary');
        this.gameplayScreenShotSwapHandler('.gameplay__images__fight');
        this.gameplayScreenShotSwapHandler('.gameplay__images__reward');
        this.gameplayScreenShotSwapHandler('.gameplay__images__invade');
        this.gameplayScreenShotSwapHandler('.gameplay__images__supply');
        this.gameplayScreenShotSwapHandler('.gameplay__images__prize');
        this.gameplayScreenShotSwapHandler('.gameplay__images__carryout');
        this.gameplayScreenShotSwapHandler('.gameplay__images__enemies');
        this.gameplayScreenShotSwapHandler('.gameplay__images__coliseum');
        this.gameplayScreenShotSwapHandler('.gameplay__images__explore');
        this.imageList = this.importAll(require.context('../../img/gameplay', false, /\.(webp|jpg)$/));
        this.setupBackgroundVideo();
        this.preloadImages();
        this.setupBackgroundImageParallax();
        this.onPageLoadingImageRotation();
    }
    stopImageRotation(pictureElement) {
        if (pictureElement) {
            const interval = this.imageRotationIntervals.get(pictureElement);
            if (interval) {
                clearInterval(interval);
                this.imageRotationIntervals.delete(pictureElement);
            }
        }
        else {
            this.imageRotationIntervals.forEach((interval, element) => {
                clearInterval(interval);
            });
            this.imageRotationIntervals.clear();
        }
    }
    createPictureElementString(newBaseSrc) {
        const webp640 = require(`../../img/gameplay/${newBaseSrc}_ss_640.webp`);
        const jpg1300 = require(`../../img/gameplay/${newBaseSrc}_ss_1300.jpg`);
        const webp1300 = require(`../../img/gameplay/${newBaseSrc}_ss_1300.webp`);
        const jpg640 = require(`../../img/gameplay/${newBaseSrc}_ss_640.jpg`);
        const newPictureHTML = `
      <source type="image/webp" media="(max-width:640px)" srcset="${webp640}" />
      <source type="image/jpg" media="(min-width:641px)" srcset="${jpg1300}" />
      <source type="image/webp" media="(min-width:641px)" srcset="${webp1300}" />
      <img src="${jpg640}" alt="Gameplay image" class="gameplay__image__group--large" />
    `;
        return newPictureHTML;
    }
    startImageRotation(pictureElement, baseName) {
        let isToggled = false;
        const imgElement = pictureElement.querySelector('img');
        const sourceElements = pictureElement.querySelectorAll('source');
        if (!imgElement)
            return;
        // Clear existing interval
        const existingInterval = this.imageRotationIntervals.get(pictureElement);
        if (existingInterval) {
            clearInterval(existingInterval);
        }
        const interval = window.setInterval(() => {
            let nextName = baseName;
            if (baseName === 'spoils') {
                nextName = isToggled ? baseName : 'spoils4';
            }
            else if (baseName === 'spoils2') {
                nextName = isToggled ? baseName : 'spoils5';
            }
            else if (baseName === 'prize') {
                nextName = isToggled ? baseName : 'prize2';
            }
            else if (baseName === 'fusion') {
                nextName = isToggled ? baseName : 'fusion5';
            }
            else if (baseName === 'supply2') {
                nextName = isToggled ? baseName : 'supply3';
            }
            else if (baseName === 'enemies') {
                nextName = isToggled ? baseName : 'enemies7';
            }
            else if (baseName === 'enemies3') {
                nextName = isToggled ? baseName : 'enemies8';
            }
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = this.createPictureElementString(nextName);
            const newImg = tempDiv.querySelector('img');
            const newSources = tempDiv.querySelectorAll('source');
            if (newImg && newImg.src !== imgElement.src) {
                pictureElement.style.opacity = '0';
                setTimeout(() => {
                    imgElement.src = newImg.src;
                    sourceElements.forEach((sourceEl, i) => {
                        const newSource = newSources[i];
                        if (newSource) {
                            const srcset = newSource.getAttribute('srcset');
                            const type = newSource.getAttribute('type');
                            const media = newSource.getAttribute('media');
                            if (srcset)
                                sourceEl.setAttribute('srcset', srcset);
                            if (type)
                                sourceEl.setAttribute('type', type);
                            if (media)
                                sourceEl.setAttribute('media', media);
                        }
                    });
                    pictureElement.style.opacity = '1';
                    isToggled = !isToggled;
                }, 150);
            }
        }, 2500);
        this.imageRotationIntervals.set(pictureElement, interval);
    }
    onPageLoadingImageRotation() {
        const entries = [
            ['.gameplay__images__spoils', 'spoils'],
            ['.gameplay__images__prize', 'prize'],
            ['.gameplay__images__fusion', 'fusion'],
            ['.gameplay__images__supply', 'supply'],
            ['.gameplay__images__enemies', 'enemies'],
        ];
        entries.forEach(([selector, baseName]) => {
            const container = document.querySelector(selector);
            if (!container)
                return;
            const pictureElement = container.querySelector('.gameplay__image__group picture');
            if (pictureElement) {
                this.startImageRotation(pictureElement, baseName);
            }
        });
    }
    setupBackgroundVideo() {
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
            const existingVideo = document.querySelector('.gameplay__bg__video');
            if (existingVideo) {
                existingVideo.remove();
            }
        }
    }
    preloadImages() {
        const preloadContainerId = 'preload-container';
        // Create the container if it doesn't exist
        let container = document.getElementById(preloadContainerId);
        if (!container) {
            container = document.createElement('div');
            container.id = preloadContainerId;
            container.classList.add('visually-hidden');
            document.body.appendChild(container);
        }
        else {
            container.innerHTML = '';
        }
        this.imageList.forEach(src => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                this.imageCache[src] = img;
                // Clone and insert into hidden DOM to guarantee caching
                const domImg = document.createElement('img');
                domImg.src = src;
                container?.appendChild(domImg);
            };
            img.onerror = error => {
                console.error(`Failed to load image: ${src}`, error);
            };
        });
    }
    setupBackgroundImageParallax() {
        const sections = document.querySelectorAll('.gameplay__group');
        sections.forEach(section => {
            const pictureElement = section.querySelector('.gameplay__selection__bg');
            const wrapper = section.querySelector('.gameplay__selection__wrapper');
            if (!pictureElement || !wrapper) {
                console.error('No picture or wrapper found in the section');
                return;
            }
            // Helper function to update the background position
            const updateBackgroundPosition = () => {
                const sectionRect = section.getBoundingClientRect();
                const scrollPosition = window.scrollY;
                const moveAmount = (scrollPosition - sectionRect.top) * 0.03 - 30; // Subtle movement
                // Apply the transformation
                if (window.innerWidth <= 1200) {
                    pictureElement.style.transform = `translateX(0%) translateY(${moveAmount}px)`;
                }
                else {
                    pictureElement.style.transform = `translateX(-50%) translateY(${moveAmount}px)`;
                }
            };
            // Set initial position of the background image on page load
            updateBackgroundPosition();
            window.addEventListener('scroll', () => {
                // Update the background position during scrolling
                updateBackgroundPosition();
            });
        });
    }
}
exports.Gameplay = Gameplay;
